import { Dropdown } from '@creditsights/styleguide-web';
import { OnOptionSelect } from '@creditsights/styleguide-web/components/Dropdown/Dropdown.types';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';
import { SortOption } from '../../../services/services.constants';
import styles from './SortSelect.module.scss';

const cx = classNames.bind(styles);

export const SORT_OPTION_LABELS: Record<string, string> = {
  [SortOption.relevance]: 'Relevancy',
  [SortOption.publishDate_desc]: 'Latest',
};

interface SortSelectProps {
  options: SortOption[];
  onOptionSelect: (value: SortOption) => void;
  selectedOption: SortOption;
}

const getDropdownOptions = (options: SortOption[]): DropdownItemProps[] =>
  options.map((option) => ({
    text: SORT_OPTION_LABELS[option],
    value: option,
    key: option,
    'data-testid': `sort-by-${option}`,
  }));

const SortSelect = ({ options, onOptionSelect, selectedOption }: SortSelectProps): ReactElement => {
  return (
    <div className={cx('body')}>
      <span className={cx('title')}>Sort</span>
      <Dropdown
        className={cx('dropdown')}
        onOptionSelect={onOptionSelect as OnOptionSelect}
        options={getDropdownOptions(options)}
        value={selectedOption}
        dataTestId="sort-select"
        withCaretIcon
        withCheckmarks
      />
    </div>
  );
};

export default SortSelect;
